import { Component, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    private filterValue$: BehaviorSubject<any>;

    constructor() {
        this.filterValue$ = new BehaviorSubject(null);
    }

    setFilterValue(filterValue: any) {
        this.filterValue$.next(filterValue);
    }

    resetFilterValueDialog() {
        this.filterValue$.next(null);
    }

    getFilterValue(): Observable<any> {
        return this.filterValue$.asObservable();
    }
}
